import { useMutation } from '@tanstack/react-query';
import api from '../../../services/api';

export interface UpdatePlanogramParams {
    id: number;
    standard_amount: number;
    planogram_code: string;
    price_list_in_cents: number;
    price_final_in_cents: number;
    price_list_in_cents_after?: number;
    price_final_in_cents_after?: number;
    should_remove_line?: boolean;
    delete: boolean;
    status: string;
    alert_level: number;
}

const updatePlanogramFetch = async (data: UpdatePlanogramParams[]) => {
    const response = await api.post<UpdatePlanogramParams[]>(
        `/product/planograms/mass-update`,
        {
            planograms: data,
        },
    );
    return response.data;
};

export const useUpdatePlanogramMutation = () => {
    return useMutation({
        mutationFn: (data: UpdatePlanogramParams[]) =>
            updatePlanogramFetch(data),
    });
};
